import React, { useEffect } from 'react';
import Hero from './Hero';
import BuiltBy from './BuiltBy';
import Testimonials from './Testimonials';
import Quadrant from './Quadrant';
import HomepageFAQ from './HomepageFAQ';
import Countdown from './Countdown';
import { REACT_APP_DOCS_URL } from '../../constants/config';

const EU_PTD_TARGET_DATE = new Date(2026, 5, 7); // June 7, 2026 - zero-indexed! 5=June

function Home() {
  useEffect(() => {
    const fadeUpElements = document.querySelectorAll('.fade-up');

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target); // Stop observing once it's visible
          }
        });
      },
      {
        threshold: 0.08, // Adjust this value as needed
        // rootMargin: "0px 0px -20% 0px", // Adjust the bottom margin to prevent early exit
      },
    );

    fadeUpElements.forEach((element) => {
      observer.observe(element);
    });

    return () => {
      fadeUpElements.forEach((element) => {
        observer.unobserve(element);
      });
    };
  }, []);

  return (
    <>
      <Hero />
      <BuiltBy />
      <Countdown
        targetDate={EU_PTD_TARGET_DATE}
        deadlineUpcomingMessage="until the EU Pay Transparency Directive goes live"
        deadlinePassedMessage="The EU Pay Transparency Directive is live as of"
        locale="en-GB"
        callToActionUrl={`${REACT_APP_DOCS_URL}/news/tags/eu-pay-transparency-directive`}
      />
      <Testimonials />
      <Quadrant />
      <HomepageFAQ />
    </>
  );
}

export default Home;
